import React from 'react';
import { SkyrimSlider } from '../../../components/SkyrimSlider/SkyrimSlider';
import CheckBox from '../../checkbox/index';
import './styles.scss';

const Settings = (props: {
  fontSize: number,
  setFontSize: (size: number) => void,
  isSoundsDisabled: boolean,
  setDisableSounds: (disable: boolean) => void,
  showSendButton: boolean,
  setShowSendButton: (value: boolean) => void,
  visibilityMode: string,
  setVisibilityMode: (mode: string) => void,
  fov: number,
  minFov: number,
  maxFov: number,
  setFov: (value: number) => void,
  highlightWords: string,
  setHighlightWords: (words: string) => void,
}) => {
  return (
    <div className='chat-settings'>
      <div className='content'>
        <SkyrimSlider text={'taille de police'} name={'fontSize'} min={14} max={22} setValue={(value) => props.setFontSize(value)} sliderValue={props.fontSize} marks={[14, 15, 16, 17, 18, 19, 20, 21, 22]}/>
        <SkyrimSlider text={'champ de vision (/fov)'} name={'fov'} min={props.minFov} max={props.maxFov} setValue={(value) => props.setFov(value)} sliderValue={props.fov} marks={[50, 70, 90, 110, 130, 150, 170]}/>
        <CheckBox text={'sons des dés'} initialValue={!props.isSoundsDisabled} setChecked={(value) => props.setDisableSounds(!value)} disabled={false} />
        <CheckBox text={'bouton d\'envoi'} initialValue={props.showSendButton} setChecked={props.setShowSendButton} disabled={false} />
        {/* key forces a remount when the mode changes elsewhere, since CheckBox tracks its own checked state internally */}
        <CheckBox key={`visible-${props.visibilityMode}`} text={'Chat toujours visible'} initialValue={props.visibilityMode === 'visible'} setChecked={(checked) => checked && props.setVisibilityMode('visible')} disabled={false} />
        <CheckBox key={`onactivity-${props.visibilityMode}`} text={'Chat visible sur activité'} initialValue={props.visibilityMode === 'onActivity'} setChecked={(checked) => checked && props.setVisibilityMode('onActivity')} disabled={false} />
        <CheckBox key={`hidden-${props.visibilityMode}`} text={'Chat masqué'} initialValue={props.visibilityMode === 'hidden'} setChecked={(checked) => checked && props.setVisibilityMode('hidden')} disabled={false} />
        <label className='highlight-words'>
          <span>mots surlignés (séparés par des virgules)</span>
          <input
            type='text'
            value={props.highlightWords}
            maxLength={200}
            placeholder='mon prénom, taverne...'
            spellCheck={false}
            onChange={(e) => props.setHighlightWords(e.target.value)}
          />
        </label>
      </div>
    </div>
  );
};

export default Settings;
